var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValigetta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 18.472999",
    width: 20,
    height: 18.473,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, "\n\t.Ombra_x0020_esterna{fill:none;}\n\t.Angoli_x0020_arrotondati_x0020_2_x0020_pt{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.Riflessione_x0020_X_x0020_dinamica{fill:none;}\n\t.Smusso_x0020_morbido{fill:url(#SVGID_1_);}\n\t.Crepuscolo{fill:#FFFFFF;}\n\t.Fogliame_GS{fill:#FFDD00;}\n\t.Pompadour_GS{fill-rule:evenodd;clip-rule:evenodd;fill:#51AEE2;}\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#000000;}\n  ")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 0.70709997,
    y2: 0.70709997
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6EB"
    },
    id: "stop6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1738,
    style: {
      stopColor: "#E2E2E6"
    },
    id: "stop8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    style: {
      stopColor: "#D5D4D8"
    },
    id: "stop10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5323,
    style: {
      stopColor: "#C0BFC2"
    },
    id: "stop12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7139,
    style: {
      stopColor: "#A4A2A4"
    },
    id: "stop14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8949,
    style: {
      stopColor: "#828282"
    },
    id: "stop16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6B6E6E"
    },
    id: "stop18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4516",
    transform: "translate(-410.6,-288.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1189",
    transform: "translate(0,3.482)",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 411.6,288.63 h 18 c 0.55,0 1,0.45 1,1 v 13 c 0,0.55 -0.45,1 -1,1 h -18 c -0.55,0 -1,-0.45 -1,-1 v -13 c 0,-0.55 0.45,-1 1,-1 z",
    id: "path21",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 411.6,289.13 h 18 c 0.28,0 0.5,0.22 0.5,0.5 v 13 c 0,0.28 -0.22,0.5 -0.5,0.5 h -18 c -0.28,0 -0.5,-0.22 -0.5,-0.5 v -13 c 0,-0.27 0.23,-0.5 0.5,-0.5 z",
    id: "path23",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    className: "st1",
    d: "m 416.91,292.989 v -2.84 c 0,-0.28 0.38,-1.01 1.46,-1.01 h 4.38 c 0,0 1.43,0.09 1.47,1.13 0.04,1.04 0,2.73 0,2.73",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValigetta);
export default __webpack_public_path__ + "static/media/valigetta.bb8104de2d5f99652a20d2922c57950d.svg";
export { ForwardRef as ReactComponent };